import Model from "../../model"
import { ID, WebSource, FleetingIdea } from "../../types"

import Command, { CommandName } from "../command"
import CreateWebSourceCommand from "./create_web_source_command"

export type DeleteWebSourceCommandState = {
  id: ID
  captured?: {
    source: WebSource
    relatedIdeaIds: ID[]
    fleetingIdeas: FleetingIdea[]
  }
}

export default class DeleteWebSourceCommand extends Command {
  name: CommandName = "delete-web-source"
  state: DeleteWebSourceCommandState

  constructor(state: DeleteWebSourceCommandState) {
    super()
    this.state = state
  }

  // Possible conflicts:
  //  - source might already have been deleted (Cancel)
  resolveConflicts(model: Model): DeleteWebSourceCommandState | null {
    if (!model.getSource(this.state.id)) return null
    return this.state
  }

  local(model: Model): any {
    const source = model.fetchSource(this.state.id)
    const fleetingIdeas = model.getFleetingIdeasFromSource(this.state.id)
    for (const fleetingIdea of fleetingIdeas)
      model.deleteFleetingIdea(fleetingIdea.id)
    const relatedIdeaIds = model
      .getIdeasFromSource(this.state.id)
      .map((idea) => idea.id)
    model.deleteSource(this.state.id)
    this.state.captured = { source, relatedIdeaIds, fleetingIdeas }
  }

  undo(): Command[] {
    if (!this.state.captured) throw new Error("No captured undo state")
    return [
      new CreateWebSourceCommand({
        id: this.state.id,
        source: this.state.captured.source,
        relatedIdeaIds: this.state.captured.relatedIdeaIds,
        fleetingIdeas: this.state.captured.fleetingIdeas,
      }),
    ]
  }
}
